import React, { useEffect, useState } from 'react';
import { FaIcons, FaIcon, Button } from '@innovationnorway/component-library';
import { useTranslation } from 'react-i18next';
import { useCluster } from 'src/features/cluster';

const CopyToClipboardComponent = ({ link }: { link: string }) => {
  const [isCopied, setIsCopied] = useState(false);
  const { t: tCommon } = useTranslation('common');

  useEffect(() => {
    if (isCopied) {
      const timer = setTimeout(() => setIsCopied(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isCopied]);

  return (
    <Button
      className="display--block"
      type="button"
      aria-label={tCommon('copyLink')}
      onClick={() => {
        navigator.clipboard.writeText(link);
        setIsCopied(true);
      }}
    >
      <FaIcon className="margin-right--1" name={isCopied ? FaIcons.Check : FaIcons.Copy} />
      {isCopied ? tCommon('copied') : tCommon('copyLink')}
    </Button>
  );
};

const CreateLinkToOpportunityForm = () => {
  const { cluster } = useCluster();

  return (
    <CopyToClipboardComponent
      link={`https://raskavklaring.innovasjonnorge.no?cid=${cluster?.id}&return_to_actor=${true}&from_system=flerbedriftsportal.no`}
    />
  );
};

export default CreateLinkToOpportunityForm;
